import {CatalogTocModel} from '../Model/CatalogModel';
import {CatalogTocEntity, CatalogTocEntityData} from '../Entity/CatalogTocEntity';

export const catalogTocMapper = (data: CatalogTocModel): CatalogTocEntity => {
  const catalogTocEntityData: CatalogTocEntityData = {
    label: data.label,
    page: data.page
  };

  return new CatalogTocEntity(catalogTocEntityData);
};
